<template lang="html">
  <div id="specs-block" class="container-fluid">
     <div class="row p-relative">
        <div :class="imageError ? 'col-md-12' : 'col-md-6' ">
          <div class="row country-block__row">
             <div class="col-lg-6 col-md-6 col-6 bg-colored counter-block__container">
                <div class="counter-block">
                  
                   <h6 class="counter__title">Topsnelheid</h6>
                   <b class="timer">{{type.nTopsnelheid}} km/u</b>
                </div>
                <div class="counter-block">
                   <h6 class="counter__title">Acceleratie</h6>
                   <b class="timer">{{type.nAcceleratie}} s</b>
                </div>
             </div>
             <div class="col-lg-6 col-md-6 col-6 bg-colored counter-block__container">
                <div class="counter-block">
                   <h6 class="counter__title">Vermogen</h6>
                   <b class="timer">{{type.Vermogen_elektromotor_kW}} kW</b>
                </div>
                <div class="counter-block">
                   <h6 class="counter__title">Koppel</h6>
                   <b class="timer">{{type.Koppel_Nm}} Nm</b>
                </div>
             </div>
          </div>
        </div>
        <div class="col-md-6 bg-img p-0" >
          <img :src="'https://media.autodisk.nl/fotos/geel/'+type.nModelID+'/16-9/900/a.jpg'" v-if="!imageError" :alt="type.cMerknaam + ' ' + type.cModelnaam" v-on:error="imageError = true;" width="100%">
        </div>

        <Shape v-if="!imageError"  class="position-absolute shape"/>
     </div>
  </div>
</template>

<script>
import Shape from '@/components/design/shape'

export default {
  props:['type'],
  components: {
    Shape
  },
  data(){
    return {
      imageError: false
    }
  }
}
</script>

<style lang="scss">
  #specs-block{
    margin-right: 0;
    margin-bottom: 30px;
    .country-block__row{
      min-height: 0;
      height: 100%;
      @media (min-width: 768px) {
      min-height: 380px;
      }
      }
    .counter-block__container{
      .counter-block {
        border-radius: 5px;
        padding: 1rem;
        background-color: lighten(#f5f6fa, 20%) !important;
        box-shadow: 0 1px 4px hsla(0, 0%, 0%, .3);
        @media (min-width: 768px) {
          border-radius: 0;
          padding: 0;
          background-color: inherit !important;
          box-shadow: none;
        }
        .counter__title {
          color: #2ecc71 !important;
          text-align: left !important;
          @media (min-width: 768px) {
            color: white !important;
            text-align: right !important;
          }
        }
        h6{
          font-weight: 600;
          font-family: Poppins,sans-serif;
          
          /*font-size: 22px;*/
          font-size: 12px;
          letter-spacing: 1px;
          padding-bottom: 5px;
          text-transform: uppercase;
          @media (min-width: 768px) {
            padding-bottom: 20px;
            font-size: 22px;
            letter-spacing: normal;
            text-transform: none;
          }
        }
        b.timer{
          font-weight: 600;
            font-family: Poppins,sans-serif;
            
            font-size: 22px;
            color: #666666; // #2ecc71
          text-align: left !important;
          @media (min-width: 768px) {
            font-weight: 600;
            font-family: Poppins,sans-serif;
            
            font-size: 22px;
            color: #666666; // #2ecc71
          }
        }
        &:nth-child(2n) {
          margin-top: 25px;
          @media (min-width: 768px) {
            margin-top: 100px;
          }
        }
      }
      padding-top: 30px !important;
      padding-bottom: 30px !important;
      @media (min-width: 768px) {
        padding-top: 60px !important;
        padding-bottom: 60px !important;
        display: flex;
        align-items: center;
        flex-direction: column;

          text-align: right !important;
        &:nth-child(odd) {
          align-items: flex-end;
        }
      }
    }



    .pattern-block{
      position: absolute;
      bottom: -10px;
      left: 0;
      transform: rotateY(180deg);
    }
    .bg-img{
      background-repeat: no-repeat;
      -webkit-background-size: cover;
      -moz-background-size: cover;
      -o-background-size: cover;
      background-size: cover;
      z-index: 999;
      border-bottom-left-radius: 8px;

      img{
            border-bottom-left-radius: 8px;
      }

    }
    .shape{
      z-index: 999;
    }
  }
</style>
